export const GLOBALS = {
  NAME: 'PROD',
  PRODUCTION: true,
  API: {
    BASE_URL: 'https://balloons-api.digitalemenschen.app',
    BALLOONS: '/balloons',
    SCAN_FOLDER: 'scans/',
  },
  TRANSLATION_PATH: './assets/i18n/',
  ANIMATION_DURATION_SECONDS: 12,
  DEFAULT_BALLOON_ICON: './assets/balloon-default.svg',
};
